import UltMeta, { Meta } from "./UltMeta/index";
// 安装推广佣金
/**
 * 状态
 */
class State extends UltMeta {
    UNSETTLED = new Meta(1, "未结算");
    SETTLED = new Meta(2, "已结算");
}

export const STATE = new State();

class SettlementType extends UltMeta {
    WX = new Meta(1, "微信");
}

export const SETTLEMENT_TYPE = new SettlementType();
